const BREAKPOINTS_DEVICES = {
  MOBILE: 320,
  MOBILEBIG: 480,
  PHABLET: 660,
  TABLET: 768,
  DESKTOP: 960,
  WIDE: 1366
};

const NEWSLETTER_PRODUCT = 'dockWalk';

const PRIVACY = {
  HREF: 'https://privacy.informa.com/policies/en/',
  NAME: 'Privacy Policy',
  TERMS_HREF: 'https://www.boatinternational.com/terms-of-use'
};

const FOOTER_DATA = {
  COPYRIGHT_LINE_1:
    '© 2026 Dockwalk, part of the Boat International Media Group. All rights reserved.',
  COPYRIGHT_LINE_2:
    '"Dockwalk Presents" are advertisement features and Dockwalk/Boat International Media has been paid to include this content',
  MENUS: [
    { href: '/contact-us', name: 'Contact' },
    { href: '/advertise', name: 'Advertise with us' },
    { href: '/dockwalk-presents', name: 'Dockwalk Presents' },
    { href: '/terms-conditions', name: 'Terms & Conditions' },
    { href: PRIVACY.HREF, name: 'Privacy Policy' },
    { href: '/cookies', name: 'Cookie Policy' },
    { href: '/newsletter', name: 'Newsletter' },
    { href: '/sitemap', name: 'Site map' }
  ]
};

const HEADER_MENUS_OLD = [
  {
    name: 'News',
    href: '/news',
    items: []
  },
  {
    name: 'Crew Life',
    href: '/crewlife',
    items: [
      { itemKey: 1, href: '/crewlife/captains', name: 'Captains' },
      { itemKey: 2, href: '/crewlife/engineers', name: 'Engineers' },
      { itemKey: 3, href: '/crewlife/stews', name: 'Stews' },
      { itemKey: 4, href: '/crewlife/deckhands', name: 'Deckhands' },
      { itemKey: 5, href: '/crewlife/chefs', name: 'Chefs' },
      { itemKey: 6, href: '/downtime', name: 'Downtime' }
    ]
  },
  {
    name: 'Jobs',
    href: '/jobs',
    items: [
      { itemKey: 1, href: '/jobs/career-advice', name: 'Career Advice' },
      { itemKey: 2, href: '/jobs/salary-guide', name: 'Salary Guide' },
      { itemKey: 3, href: '/jobs/training', name: 'Training' }
    ]
  },
  {
    name: 'Superports',
    href: '/superports',
    items: []
  },
  {
    name: 'Awards',
    href: '/awards',
    items: []
  },
  {
    name: 'Dockwalk Presents',
    href: '/dockwalk-presents'
  },
  {
    name: 'Digital Dockwalk',
    href: '/digital-dockwalk',
    items: []
  },
  {
    name: 'Subscribe',
    href: 'https://www.dockwalk.com/subscribe',
    items: []
  }
];

const HEADER_MENUS_NEW = [
  {
    name: 'Captains & Senior Crew',
    href: '/crewlife/captains',
    items: []
  },
  {
    name: 'Crew Advice',
    href: '/crewlife',
    items: [
      { itemKey: 1, href: '/crewlife/engineers', name: 'Engineers' },
      { itemKey: 2, href: '/crewlife/stews', name: 'Stews' },
      { itemKey: 3, href: '/crewlife/chefs', name: 'Chefs' },
      { itemKey: 4, href: '/crewlife/deckhands', name: 'Deckhands' },
      { itemKey: 5, href: '/crew-welfare', name: 'Crew Welfare' }
    ]
  },
  {
    name: 'Superports',
    href: '/superports',
    items: []
  },
  {
    name: 'News',
    href: '/news',
    items: []
  },
  {
    name: 'Jobs',
    href: '/jobs',
    items: [
      { itemKey: 1, href: '/jobs/salary-guide', name: 'Salary Guide' },
      { itemKey: 2, href: '/jobs/training', name: 'Training' }
    ]
  },
  {
    name: 'Dockwalk Presents',
    href: '/dockwalk-presents',
    items: []
  },
  {
    name: 'Newsletters',
    href: '/newsletter',
    items: []
  }
];

const HEADER_MENUS =
  process.env.USE_NEW_HEADER_MENUS === 'true' ? HEADER_MENUS_NEW : HEADER_MENUS_OLD;

const imageSizes = {
  standardWidths: {
    '320w': {
      r: {
        width: 320
      }
    },
    '480w': {
      r: {
        width: 480
      }
    },
    '660w': {
      r: {
        width: 660
      }
    },
    '768w': {
      r: {
        width: 768
      }
    },
    '960w': {
      r: {
        width: 960
      }
    },
    '1280w': {
      r: {
        width: 1280
      }
    }
  },
  '16:9': {
    '320w': {
      r: {
        width: 320,
        height: 180
      }
    },
    '480w': {
      r: {
        width: 480,
        height: 270
      }
    },
    '660w': {
      r: {
        width: 660,
        height: 371
      }
    },
    '768w': {
      r: {
        width: 768,
        height: 432
      }
    },
    '960w': {
      r: {
        width: 960,
        height: 540
      }
    },
    '1280w': {
      r: {
        width: 1280,
        height: 720
      }
    }
  }
};

const RESPONSIVE_IMAGE_CONFIG = process.env.DISABLE_RESPONSIVE_IMAGES
  ? null
  : {
      sizes: {
        socialMeta: {
          single: {
            r: {
              width: 1280
            }
          }
        },
        'card:landscape:grid--one:sidebar-card': {
          widths: {
            '320w': imageSizes['16:9']['320w'],
            '660w': imageSizes['16:9']['660w']
          },
          sizes: '(max-width: 960px) 40vw, 10vw'
        },

        'card:portrait:grid--two': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 768px) 100vw, 50vw'
        },
        'card:portrait:grid--three': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 768px) 100vw, 33vw'
        },
        'card:portrait:grid--four': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 768px) 50vw, 25vw'
        },
        'card:landscape:grid--two': {
          widths: imageSizes['16:9'],
          sizes: '(max-width: 768px) 40vw, 10vw'
        },
        'card:landscape:grid--one': {
          widths: imageSizes['16:9'],
          sizes: '40vw'
        },
        card: {
          widths: imageSizes['16:9'],
          sizes: '100vw'
        },
        globalLightbox: {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        image: {
          widths: imageSizes.standardWidths,
          sizes: '100vw'
        },
        'image:author-details': {
          widths: {
            '140w': {
              r: {
                width: 140
              }
            }
          },
          sizes: '10vw'
        },
        carousel: {
          widths: {
            // 525w is wrong but will trigger srcset correctly
            '525w': {
              r: {
                height: 350
              }
            }
          },
          sizes: '100vw'
        }
      }
    };

export {
  BREAKPOINTS_DEVICES,
  FOOTER_DATA,
  HEADER_MENUS,
  NEWSLETTER_PRODUCT,
  RESPONSIVE_IMAGE_CONFIG,
  PRIVACY
};
